// extracted by mini-css-extract-plugin
export default {"form-wrapper":"ModalCropper_form-wrapper__Uy72q","input-wrapper":"ModalCropper_input-wrapper__LKp8z","cropper-wrapper":"ModalCropper_cropper-wrapper__WVt+S"};